import { render, staticRenderFns } from "./HistoryMovements.vue?vue&type=template&id=48d0f034"
import script from "./HistoryMovements.vue?vue&type=script&lang=js"
export * from "./HistoryMovements.vue?vue&type=script&lang=js"
import style0 from "./HistoryMovements.vue?vue&type=style&index=0&id=48d0f034&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports